import { dbPost } from '../../apis/commonApi';

class ReqVideoController {
  constructor(
    { store, updateStore },
    { pageParam, setPageParam },
    { taskInfo, setTaskInfo },
    { workList, setWorkList },
    modalService,
    validateService,
    navigate
  ) {
    this.store = store;
    this.updateStore = updateStore;
    this.pageParam = pageParam;
    this.setPageParam = setPageParam;
    this.taskInfo = taskInfo;
    this.setTaskInfo = setTaskInfo;
    this.workList = workList;
    this.setWorkList = setWorkList;
    this.modalService = modalService;
    this.validateService = validateService;
    this.navigate = navigate;
  }

  async fnSearch() {
    const url = '/aia/analysis/video/req/list.do';

    const param = {
      entSn: this.pageParam?.entSn,
      aiaAplyId: this.pageParam?.aiaAplyId,
    };

    let response;

    try {
      response = await dbPost(url, param);

      if (response instanceof Error) {
        this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
      } else {
        this.setTaskInfo(response?.videoTaskInfo);
        this.setWorkList(response?.videoWorkList);
      }
    } catch (e) {
      this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
    }
  }

  async fnApply() {
    const url = '/aia/analysis/video/req/apply.do';
    const param = {
      entSn: this.pageParam?.entSn,
      aiaAplyId: this.pageParam?.aiaAplyId,
    };

    let response;

    try {
      response = await dbPost(url, param);

      if (response instanceof Error) {
        this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
      } else {
        this.modalService.successAlert('신청되었습니다.', () => {
          this.fnSearch();
        });
      }
    } catch (e) {
      this.modalService.errorAlert('처리중 에러가 발생하였습니다.', () => {});
    }
  }

  async fnGoToPrevPage() {
    const movePrev = () => {
      const state = {
        flag: 'ex',
        entSn: this.pageParam?.entSn,
        aiaAplyId: this.pageParam?.aiaAplyId,
      };

      this.navigate('/ai/surveyCheck', {
        state: state,
      });
    };

    this.modalService.confirmAlert(
      {
        msg: '(이전화면) 체크리스트 수정화면으로 이동하시겠습니까?',
      },
      [
        () => {
          movePrev();
        },
        () => {},
      ]
    );
  }

  async fnGoToNextPage() {
    // this.navigate('/ai/basicSurveyFirst', {
    //   state: {
    //     flag: 'new',
    //     entSn: this.pageParam?.entSn,
    //     aiaAplyId: this.pageParam?.aiaAplyId,
    //   },
    // });

    if (this.workInfo?.addCnt > 0) {
      this.navigate('/ai/basicSurveyFirst', {
        state: {
          flag: 'new',
          entSn: this.pageParam?.entSn,
          aiaAplyId: this.pageParam?.aiaAplyId,
        },
      });
    } else {
      const moveAdd = () => {
        this.navigate('/ai/resVideoList', {
          state: {
            flag: 'ex',
            entSn: this.pageParam?.entSn,
            aiaAplyId: this.pageParam?.aiaAplyId,
          },
        });
      };

      const moveSrvy = () => {
        this.navigate('/ai/basicSurveyFirst', {
          state: {
            flag: 'new',
            entSn: this.pageParam?.entSn,
            aiaAplyId: this.pageParam?.aiaAplyId,
          },
        });
      };

      this.modalService.confirmAlert(
        {
          msg: '기본조사표 작성 전, 부가정보입력 화면으로 이동합니다.',
        },
        [
          () => {
            moveAdd();
          },
          () => {
            moveSrvy();
          },
        ]
      );
    }
  }
}

export default ReqVideoController;
